<template>
    <el-drawer
        title="演出代理商结款信息"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <template v-if="data">
                <div v-if="data.receivablesInfo" class="group">
                    <div class="page-group-title"><span>基本信息</span></div>
                    <table class="info-table MT20" width="100%">
                        <tr>
                            <th>收款联系人姓名</th>
                            <td>{{data.receivablesInfo.userName}}</td>
                            <th>收款联系人手机</th>
                            <td>{{data.receivablesInfo.userTelephone}}</td>
                        </tr>
                        <tr>
                            <th>收款联系人邮箱</th>
                            <td>{{data.receivablesInfo.userEmail}}</td>
                            <th>通讯地址</th>
                            <td>{{data.receivablesInfo.address}}</td>
                        </tr>
                        <tr>
                            <th>银行</th>
                            <td>{{data.receivablesInfo.bankName}}</td>
                            <th>开户网点</th>
                            <td>{{data.receivablesInfo.bankAddress}}</td>
                        </tr>
                        <tr>
                            <th>卡号</th>
                            <td>{{data.receivablesInfo.bankCardId}}</td>
                            <th>账户名</th>
                            <td>{{data.receivablesInfo.bankAccount}}</td>
                        </tr>
                        <tr>
                            <th>账户性质</th>
                            <td>{{data.receivablesInfo.accountType == 1 ? '企业' : '个人'}}</td>
                            <th>合同编号</th>
                            <td>{{data.receivablesInfo.contractSn}}</td>
                        </tr>
                    </table>
                </div>
                <div class="group MT20">
                    <div class="page-group-title"><span>结款参考</span></div>
                    <table class="info-table MT20" width="100%">
                        <tr>
                            <th>演出ID</th>
                            <td>{{data.activityId}}</td>
                            <th>演出名称</th>
                            <td>{{data.title}}</td>
                        </tr>
                        <tr>
                            <th>代理商ID</th>
                            <td>{{data.agentUser.id}}</td>
                            <th>代理商名称</th>
                            <td>{{data.agentUser.name}}</td>
                        </tr>
                        <tr v-if="data.receivablesUserId">
                            <th>结款方</th>
                            <td>[{{$userType.get(data.receivablesUserType)}}]{{data.receivablesUserName}}</td>
                            <th>结款方ID</th>
                            <td>{{data.receivablesUserId}}</td>
                        </tr>
                        <tr>
                            <th>销售票数</th>
                            <td>{{data.saleTicketNum}}</td>
                            <th>销售金额</th>
                            <td class="color-danger">{{data.saleAmountFormat}}</td>
                        </tr>
                        <tr>
                            <th>实际收入</th>
                            <td>{{data.amountFormat}}</td>
                            <th>优惠</th>
                            <td>
								<p>秀动承担优惠：{{data.platDiscountFormat}}</p>
								<p>B类承担优惠：{{data.busDiscountFormat}}</p>
							</td>
                        </tr>
                        <tr>
							<th>退票手续费</th>
							<td>{{data.refundFeeStr}}</td>
                            <th>秀动服务费</th>
                            <td>
                                <p>收费方式：
									<span v-if="data.serviceFeeType == 0">不收取</span>
									<span v-if="data.serviceFeeType == 1">固定金额</span>
									<span v-if="data.serviceFeeType == 2">按比例收取({{data.serviceFee}})</span>
								</p>
								<p class="color-danger">服务费用：{{data.serviceFeeAmountFormat}}</p>
                            </td>                           
                        </tr>
						<!-- <tr>
							<th>服务费用</th>
							<td class="color-danger">{{data.serviceFeeAmountFormat}}</td>
							<th></th>
							<td></td>
						</tr> -->
						<tr>
                            <th>抖音服务费</th>
						    <td class="color-danger">{{data.byteMiniServiceFeeAmountFormat }}</td>
						    <th>大麦服务费</th>
						    <td><!-- {{data.damaiServiceFee}} -->
								<p>收费比例：{{data.damaiServiceFee}}</p>
								<p class="color-danger">服务费用：{{data.damaiServiceFeeAmountFormat}}</p>
							</td>
						</tr>
						<tr>						    					    
							<th>抖音CPS佣金</th>
							<td>{{data.byteMiniCPSAmountFormat }}</td>
							<th>代理商服务费</th>
							<td>
                                <p>收费方式：
									<span v-if="data.agentServiceFeeType == 0">不收取</span>
									<span v-if="data.agentServiceFeeType == 1">固定金额</span>
									<span v-if="data.agentServiceFeeType == 2">按比例收取({{data.agentServiceFee}})</span>
								</p>
								<p class="color-danger">服务费用：{{data.agentServiceFeeAmountFormat}}</p>
                            </td>
						</tr>
						<tr>
							<th>小红书小程序服务费</th>
							<td>{{data.redBookletServiceFeeAmountFormat }}</td>
							<th>小红书小程序CPS佣金</th>
							<td>{{data.redBookletCPSAmountFormat }}</td>
						</tr>
                    </table>
                </div>
                <div v-if="data && data.receivablesInfo" class="group MT20">
                    <div class="page-group-title"><span>结款信息</span></div>
                    <SettlementEdit v-if="drawerShow" ref="settlementEdit" :formData.sync="data" :btnLoading.sync="btnLoading"></SettlementEdit>
                </div>
            </template>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="onSubmit()" :loading="btnLoading" :disabled="data && data.status == 2">提 交</el-button>
        </div>
    </el-drawer>
</template>

<script>
import SettlementEdit from './settlementEdit';
export default {
    components:{SettlementEdit},
    data(){
        return{
            drawerShow: false,
            dataLoading:false,
            btnLoading:false,
            id:'',
            data: null,
        }
    },
    methods:{
        close(){
            if(this.$refs.formData) this.$refs.formData.resetFields();
            this.data = null;
            this.drawerShow = false;
        },
        show(id){
            this.id = id || '';
            this.btnLoading = false;
            if(id){
                this.getData();
            }
            this.drawerShow = true;
        },
        //获取详情
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/agent/settle/info',
                params: {activityId: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = {
                            ...result, 
                            playPic: result.playPic || [], 
                            fileList: result.playPic ? result.playPic.map( v => {return {url: v}}) : []
                        };
                        // this.drawerShow = true;
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        onSubmit(){
            this.$refs.settlementEdit.onSubmit(() => {
                this.$emit('onUpdate');
                this.close();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.info-table{
    th{
        min-width: 80px;
        text-align: right;
    }
    td{
        min-width: 150px;
    }
}
</style>